import template from './delegatedCardRow.html';
import controller from './delegatedCardRow.controller';
import './delegatedCardRow.scss';

let delegatedCardRowComponent = {
  restrict: 'E',
  bindings: {
    currentEmployee: '<',
    processEmployee: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default delegatedCardRowComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/delegatedCardRow.component.js